import React, { useState, useEffect, useRef } from 'react';
import DataTableLayout from '../../../../utility/table/DataTableLayout.jsx'
import CommonComponent from "../../CommonComponent"
import { ReportProcessingsTableData } from '../../Common/Datatable';


const ReportProcessings = ()=> {
  const { tableId, ajaxUrl, columns } = ReportProcessingsTableData;
  return (
    <>
      <CommonComponent />
      <section className="section dashboard py-2">
        <DataTableLayout tableId={tableId} ajaxUrl={ajaxUrl} columns={columns} />
      </section>
    </>
  );
}


export default ReportProcessings;